module.exports = __webpack_public_path__ + "img/features_pic03.833b19d9.png";